import * as z from "zod";

export const RecognizeAudienceReturnCondition = z.object({
  operator: z.enum(["equal_to", "at_least", "at_most"]),
  count: z.number().int().nonnegative(),
  reason: z.string().trim().max(200).optional(),
});
export type RecognizeAudienceReturnCondition = z.infer<
  typeof RecognizeAudienceReturnCondition
>;
